import { Helmet } from "react-helmet";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import CollectFeesBox from "../../../../components/PagesComponents/Financial/CashInFlow/Fees/CollectFeesBox.component";
import NormalFeesBox from "../../../../components/PagesComponents/Financial/CashInFlow/Fees/NormalFeesBox.component";
import "../../../../styles/Pages/Financial/CashInFlow/Fees/Fees.style.css";
import ScheduleFeesBox from "../../../../components/PagesComponents/Financial/CashInFlow/Fees/ScheduleFeesBox.component";
import FeesCollectedSuccesfully from "../../../../components/PagesComponents/Financial/CashInFlow/Fees/FeesCollectedSuccesfully.component";
import FeeReceipt from "../../../../components/PagesComponents/Financial/CashInFlow/Fees/FeeReceipt.component";
import { useState } from "react";
import AllFeesCollection from "../../../../components/PagesComponents/Financial/CashInFlow/Fees/AllFeesCollection.component";
import ScrollableModal from "../../../../components/Universal/ScrollableModal.component";

const Body = () => {
  const [isRecipetModelOpen, setIsRecipetModelOpen] = useState(false);
  const [allCollectionActive, setIsAllCollectionActive] = useState(false);
  return (
    <section className="cashInFlowFees pb-1">
      <ScrollableModal
        isOpen={isRecipetModelOpen}
        onClose={() => setIsRecipetModelOpen(false)}
      >
        <FeeReceipt />
      </ScrollableModal>
      <Helmet>
        <title>Fees</title>
        <meta
          name="description"
          content="A powerful organization management system to streamline workflows and improve efficiency."
        />
        <meta
          name="keywords"
          content="organization management, workflow automation, business management, employee tracking"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader
        title={"Fees"}
        renderCustomElement={
          <button
            onClick={() => setIsAllCollectionActive(!allCollectionActive)}
            className="blueActionBtnLight toggleActionBtn"
          >
            <input type="checkbox" />{" "}
            <span className="box">All Fees Collection</span>
          </button>
        }
      />
      {!allCollectionActive ? (
        <div className="FeesMainBodyContainer">
          <div className="CollectFees">
            <CollectFeesBox />
          </div>
          <div className="feesBox">
            <NormalFeesBox />
            <ScheduleFeesBox />
            <FeesCollectedSuccesfully openModel={setIsRecipetModelOpen} />
          </div>
        </div>
      ) : (
        <AllFeesCollection />
      )}
    </section>
  );
};

export default Body;
